import { numberSchemaValidator as validate } from 'schemas/ajv-validators';
import { validateWithAjv } from './validate-with-ajv';

export const validateNumber = (value: unknown) => validateWithAjv(validate, value);
